<ng-template #quoteToolbar>
    <div class="quote-toolbar-row compact-toolbar">
        <div class="toolbar-search">
            <label>Search</label>
            <slick-search-bar [showSearchIcon]="false" placeholder="Search quotes..." [ngModel]="searchText" (onSearch)="onSearch($event)" [showAddButton]="false" [showEditButton]="false"></slick-search-bar>
        </div>
        <div class="toolbar-field quote-months" [class.d-none]="hideFilters">
            <label>Show quotes from</label>
            <slick-drop-down [ngModel]="selectedEstimateMonths" [items]="estimateMonths" allowEmpty="false" (onChange)="onEstimateMonthsChanged($event)"></slick-drop-down>
        </div>
        <div class="toolbar-field batch-actions">
            <label>Batch Actions</label>
            <slick-drop-down placeholder="Batch Actions" [items]="dashboardFilter === 'won' ? nonConversionBatchItems : batchItems" [(ngModel)]="batchActionId"></slick-drop-down>
            <form-error *ngIf="isSubmitted && !batchActionId">Batch action required</form-error>
        </div>
        <button [disabled]="!batchActionId || gridModelsForBatch.length === 0" type="button" class="btn btn-sm btn-outline-primary" (click)="performBatch()">Go</button>
        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="clearFilters(locations)">Clear</button>
        <div *ngIf="isJellyfish" class="dealer-filters">
            <label><input type="checkbox" [ngModel]="showDealersOnly" (change)="onShowDealersOnlyChanged()" /> Dealers Only</label>
            <label><input type="checkbox" [ngModel]="showInternalSales" (change)="onShowInternalSalesChanged()" /> Show DSM Sales</label>
        </div>
    </div>
    <div class="quote-locations-row" [class.d-none]="hideFilters">
        <locations-selector #locations displayMode="chips" key="INVOICES" (onLocationsChanged)="onLocationsChanged($event)"></locations-selector>
        <label class="pos-toggle form-switch">
            <input type="checkbox" class="form-check-input" role="switch" [ngModel]="showPOSOnly" (change)="onShowPOSOnlyChanged()" />
            <span>Show POS Only</span>
        </label>
    </div>
</ng-template>
<div class="quote-table-container d-flex flex-column hide-scroll-bar" [class.infinite-list]="infiniteScroll" [style.min-height]="infiniteScroll ? '0' : 'calc(100vh - 150px)'" [style.max-height]="infiniteScroll ? 'none' : 'calc(100vh - 150px)'" [style.border]="externalToolbar ? null : '1px solid #ced4da'" [style.border-radius]="externalToolbar ? null : '6px'">
<ng-container *ngIf="!externalToolbar">
	<div class="d-flex">
		<div class="d-flex col-6">
			<div>
				<slick-search-bar (onSearch)="onSearch($event)" [showAddButton]="false" [showEditButton]="false"></slick-search-bar>
			</div>
			<div *ngIf="!hideNewButton" class="ms-2">
				<button type="button"
						class="btn btn-outline-primary"
						style="width: 80px; border-radius: 19px;"
						(click)="onNewEstimate()">
					<i class="far fa-plus"></i>
					<span class="d-none d-xl-inline-block">&nbsp;New</span>
				</button>
			</div>
		</div>



		<div class="d-flex col-6" style="justify-content:flex-end">
			<div class="ms-2 me-1 p-0">

				<slick-drop-down placeholder="Batch Actions" [items]="batchItems" [(ngModel)]="batchActionId"></slick-drop-down>
				<form-error *ngIf="isSubmitted && !batchActionId">Batch action required</form-error>
			</div>

			<button [disabled]="!batchActionId || gridModelsForBatch.length === 0" type="button" class="btn btn-sm btn-outline-primary" style="min-width:55px; max-width: 55px; height: 2.5rem;" (click)="performBatch()">Go</button>
			<button class="btn btn-outline-success ms-1" (click)="exportToCSV()"> Export</button>
		</div>
	</div>

	<div [class.d-none]="hideFilters">
		<locations-selector class="mt-1" key="INVOICES" (onLocationsChanged)="onLocationsChanged($event)"></locations-selector>

		<div class="mt-2 mb-2" style="display: flex; flex-wrap: wrap; column-gap: 15px; row-gap: 8px;">
			<div>
				<div>Show quotes from</div>
				<div style="width:220px">
					<slick-drop-down [ngModel]="selectedEstimateMonths"
									 [items]="estimateMonths"
									 allowEmpty="false"
									 (onChange)="onEstimateMonthsChanged($event)">
					</slick-drop-down>
				</div>
			</div>
		</div>
		<div class="pt-1" style="font-size: .8rem; line-height: 1rem;">
			<span><input type="checkbox" [ngModel]="showPOSOnly" (change)="onShowPOSOnlyChanged()" />Show POS Only</span>
		</div>
	</div>

		<div *ngIf="isJellyfish" class="pt-1" style="font-size: .8rem; line-height: 1rem;">
			<span><input type="checkbox" [ngModel]="showDealersOnly" (change)="onShowDealersOnlyChanged()" />Dealers Only</span>&nbsp;&nbsp;
			<span><input type="checkbox" [ngModel]="showInternalSales" (change)="onShowInternalSalesChanged()" />Show DSM Sales</span>
		</div>

</ng-container>
<div *ngIf="externalToolbar" class="quote-results-toolbar">
    <div class="quote-results-count">Showing {{ estimatesGrid?.visibleData?.length || 0 }} of {{ estimatesGrid?.totalRecords || 0 }} quotes</div>
    <div class="quote-results-actions">
        <button type="button" class="btn btn-outline-success btn-sm" (click)="exportToCSV()"><i class="bi bi-download" aria-hidden="true"></i> Export</button>
        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="estimatesGrid.openColumnSelectDialog()"><i class="bi bi-layout-three-columns" aria-hidden="true"></i> Columns</button>
    </div>
</div>
		<slick-grid [useFieldTemplates]="infiniteScroll" [requiredColumns]="externalToolbar ? batchSelectionColumns : []" [infiniteScroll]="infiniteScroll" infiniteRowKey="invoiceId" (infiniteReset)="onInfiniteReset()" [showColumnSelector]="!externalToolbar" [class.mt-3]="!externalToolbar" [gridOptions]="gridOptions" (onRowSelected)="onRowClicked($event)" (onRowContextMenu)="onRowContextMenu($event)" #estimatesGrid>
            <ng-template let-quote slickGridColumnTemplate="invoiceNumber">
                <div class="quote-cell-stack">
                    <span class="quote-primary-text quote-reference">{{quote.invoiceNumber}}</span>
                    <div class="quote-status-row">
                        <span *ngIf="quote.invoiceStatusName" class="quote-status text-secondary" [title]="'Document status: ' + quote.invoiceStatusName">{{quote.invoiceStatusName.trim().toLowerCase() === 'pending on schedule' ? 'Scheduled' : quote.invoiceStatusName}}</span>
                        <span *ngIf="quote.isQuote && quote.acceptedDate" class="quote-status text-success">Accepted</span>
                    </div>
                </div>
            </ng-template>
            <ng-template let-quote slickGridColumnTemplate="displayName">
                <div class="quote-cell-stack">
                    <span class="quote-primary-text">{{quote.displayName}}</span>
                    <span *ngIf="quote.companyName && quote.fullName && quote.fullName !== quote.displayName" class="quote-secondary-text">{{quote.fullName}}</span>
                </div>
            </ng-template>
			<ng-template let-estimatesGridModel slickGridColumnTemplate="BATCH_CHECKBOX"><input type="checkbox" [ngModel]="estimatesGridModel.batch" (click)="onBatchClicked(estimatesGridModel, $event)" /></ng-template>
			<ng-template let-estimatesGridModel slickGridColumnTemplate="ACCEPTED_DATE">
				{{estimatesGridModel.acceptedDate | date:'M/d/yyyy'}}
			</ng-template>
			<ng-template let-estimatesGridModel slickGridColumnTemplate="QUOTE_DATE">
				{{estimatesGridModel.quoteDate | date:'M/d/yyyy'}}
			</ng-template>
			<ng-template let-estimatesGridModel slickGridColumnTemplate="SALES_REP">
				{{estimatesGridModel.salesRepFullName}}
			</ng-template>
		</slick-grid>


	</div>

	<slick-context-menu #estimatesGridContextMenuRef>
		<slick-context-menu-item (click)="contextMenuDeleteEstimate()"><i class="bi bi-trash"></i>&nbsp;Delete Estimate</slick-context-menu-item>
	</slick-context-menu>

	<slick-confirm-dialog #deleteEstimateConfirmRef>
		Are you sure you want to delete this estimate?
	</slick-confirm-dialog>

	<emailer-dialog #emailerDialogRef></emailer-dialog>
	<batch-payment-dialog #batchPaymentDialogRef></batch-payment-dialog>
